const fieldName = {
  COACH: 'coach',
  COACH_ID: 'coachId',
  NAME: 'formName',
  FIELDS: 'fields',
  HIDDEN_FIELDS: 'hiddenFields',
  END_SCREEN_CONTENT: 'endScreenContent',
  TEXT_BLAST_CONSENT: 'textBlastConsent',
};

const questionFieldName = {
  TYPE: 'type',
  ID: 'id',
  CUSTOM_CLASS: 'customClass',
  LABEL: 'label',
  SUB_TEXT: 'subText',
  PLACEHOLDER: 'placeholder',
  REQUIRED: 'required',
  FIELDS: 'fields',
  ALLOW_MULTIPLE: 'isMultiple',
  DISPLAY_AS_CHECKBOXES: 'displayAsCheckboxes',
  MIN_SELECTIONS: 'minSelections',
  MAX_SELECTIONS: 'maxSelections',
  PROMPT_INPUT: 'promptInput',
  OPTIONS: 'options',
  VALUE: 'value',
  UNITS: 'units',
  UNIT_IDS: 'unitIds',
};

const heightUnitId = {
  FEET: 'ft',
  INCHES: 'in',
  CM: 'cm',
};

const weightUnitId = {
  POUNDS: 'lb',
  KILOGRAMS: 'kg',
};

const endScreenContentFieldName = {
  LINE_1: 'line1',
  LINE_2: 'line2',
};

const questionId = {
  FINANCIAL_COMMITMENT: 'financialCommitment',
};

const MIN_SELECTION_LIMIT = 1;

export default fieldName;
export {
  questionFieldName,
  endScreenContentFieldName,
  heightUnitId,
  weightUnitId,
  questionId,
  MIN_SELECTION_LIMIT,
};
